/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Meta_DescriptionInputs */

const id_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang egdata.app`)
};

const ms_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perihal egdata.app`)
};

const da_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om egdata.app`)
};

const de_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über egdata.app`)
};

const en_us2_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About egdata.app`)
};

const es_es2_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de egdata.app`)
};

const es_mx2_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de egdata.app`)
};

const fil_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tungkol Sa egdata.app`)
};

const fr_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos d'egdata.app`)
};

const it_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni su egdata.app`)
};

const hu_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Névjegy az egdata.app-ról`)
};

const nl_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over egdata.app`)
};

const no_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om egdata.app`)
};

const pl_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O egdata.app`)
};

const pt_br2_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre egdata.app`)
};

const pt_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre o egdata.app`)
};

const ro_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Despre egdata.app`)
};

const fi_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietoa egdata.appista`)
};

const sv_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om egdata.app`)
};

const vi_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giới thiệu về egdata.app`)
};

const tr_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app hakkında`)
};

const cs_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O egdata.app`)
};

const bg_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Относно egdata.app`)
};

const ru_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О проекте egdata.app`)
};

const uk_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Про egdata.app`)
};

const ar_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حول egdata.app`)
};

const hi_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app के बारे में`)
};

const th_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกี่ยวกับ egdata.app`)
};

const ja_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app について`)
};

const zh_cn2_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于 egdata.app`)
};

const zh_hant1_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關於 egdata.app`)
};

const ko_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app 소개`)
};

/**
* | output |
* | --- |
* | "About egdata.app" |
*
* @param {About_Meta_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_meta_description = /** @type {((inputs?: About_Meta_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Meta_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_meta_description(inputs)
	if (locale === "ms") return ms_about_meta_description(inputs)
	if (locale === "da") return da_about_meta_description(inputs)
	if (locale === "de") return de_about_meta_description(inputs)
	if (locale === "en-US") return en_us2_about_meta_description(inputs)
	if (locale === "es-ES") return es_es2_about_meta_description(inputs)
	if (locale === "es-MX") return es_mx2_about_meta_description(inputs)
	if (locale === "fil") return fil_about_meta_description(inputs)
	if (locale === "fr") return fr_about_meta_description(inputs)
	if (locale === "it") return it_about_meta_description(inputs)
	if (locale === "hu") return hu_about_meta_description(inputs)
	if (locale === "nl") return nl_about_meta_description(inputs)
	if (locale === "no") return no_about_meta_description(inputs)
	if (locale === "pl") return pl_about_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_about_meta_description(inputs)
	if (locale === "pt") return pt_about_meta_description(inputs)
	if (locale === "ro") return ro_about_meta_description(inputs)
	if (locale === "fi") return fi_about_meta_description(inputs)
	if (locale === "sv") return sv_about_meta_description(inputs)
	if (locale === "vi") return vi_about_meta_description(inputs)
	if (locale === "tr") return tr_about_meta_description(inputs)
	if (locale === "cs") return cs_about_meta_description(inputs)
	if (locale === "bg") return bg_about_meta_description(inputs)
	if (locale === "ru") return ru_about_meta_description(inputs)
	if (locale === "uk") return uk_about_meta_description(inputs)
	if (locale === "ar") return ar_about_meta_description(inputs)
	if (locale === "hi") return hi_about_meta_description(inputs)
	if (locale === "th") return th_about_meta_description(inputs)
	if (locale === "ja") return ja_about_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_about_meta_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_meta_description(inputs)
	return ko_about_meta_description(inputs)
});
export { about_meta_description as "about.meta.description" }